import { useState } from 'react';
import MilestoneForm from './milestoneForm';
import MilestoneList from './milestoneList';
import './milestoneForm.css';

function Milestone() {
  const [selectedUid, setSelectedUid] = useState('');

  return (
    <main aria-labelledby="locations-heading">
      <h1 id="locations-heading" className="milestone-page-title">Locations</h1>
      <MilestoneForm onUidSelect={setSelectedUid} />
      <MilestoneList uid={selectedUid} />
    </main>
  );
}

export default Milestone;
